import { Injectable } from '@angular/core';

import {Observable, of} from 'rxjs';
import { ApiResponse } from '../utils';
import {PostService} from "../post/post.service";
import {GlobalService} from "../global/global.service";
import {AlertController, NavController, PopoverController} from "@ionic/angular";
import {AuthService} from "../auth/auth.service";
import {UserService} from "../user/user.service";
import {Location} from '@angular/common';
import {TranslateService} from "@ngx-translate/core";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ActionPointService {

  selectedActionPointId: number | null = null;

  constructor(
    private postService: PostService,
    private globalService: GlobalService,
    private popoverCtrl: PopoverController,
    private navController: NavController,
    private auth: AuthService,
    private location: Location,
    private userService: UserService,
    public translate: TranslateService,
    private alertController: AlertController,
  ) {}

  loadActionPointData(postId: string, sdgs: any[]): Observable<{
    item: any;
    image: string;
    createdTime: string;
    products: any;
    totalUsersRatedCount: number;
    sdgsUpdated: any[];
  }> {
    return new Observable(observer => {
      this.postService.apiGetSingleActionPoint(postId).subscribe((result: ApiResponse) => {
        if (!result.status) {
          observer.error(result.error);
          return;
        }

        const item = result.data;
        const image = item?.media?.[0]?.path || '';
        const createdTime = this.globalService.timeSince(item?.createdAt);
        const products = item?.product;
        const postMetaTitle = item?.postMeta?.title;
        if (postMetaTitle) {
          item.postMeta.title = postMetaTitle.slice(0, 30) + '...';
        }

        // Update SDG
        const updatedSdgs = [...sdgs];
        if (item?.sdgId?.length > 0) {
          item.sdgId.forEach((element) => {
            updatedSdgs.forEach((sdg) => {
              if (Number(element) === sdg.id) {
                sdg.checked = true;
              }
            });
          });
        }

        // Fetch rating statistics
        this.postService.viewRatingStatistics(postId).subscribe((response: any) => {
          const totalUsersRatedCount = response?.status ? response.data.totalUsersCount : 0;
          observer.next({
            item,
            image,
            createdTime,
            products,
            totalUsersRatedCount,
            sdgsUpdated: updatedSdgs
          });
          observer.complete();
        });
      });
    });
  }
  async editPost(item: any): Promise<void> {
    this.popoverCtrl.dismiss();

    if (item.type === 'post') {
      await this.navController.navigateForward(['/app/home/edit-post/' + item.id]);
    } else if (item.type === 'action_point' || item.type === 'adopted_action_point') {
      await this.navController.navigateForward(['/app/action-point/edit-action-point/' + item.id]);
    }
  }

  reportPost(item: any): void {
    this.popoverCtrl.dismiss();
    this.postService.reportPost(item.id).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.globalService.presentToast(result.message);
      }
    });
  }

  hidePost(item: any): void {
    this.popoverCtrl.dismiss();
    this.postService.hidePost(item.id).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.globalService.presentToast(result.message);
        this.auth.userLoggedIn.next('hardreload');
        this.location.back();
      }
    });
  }

  blockUser(item: any): void {
    this.popoverCtrl.dismiss();
    this.userService.apiBlockUser(item.createdBy.id).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.auth.userLoggedIn.next('hardreload');
        this.globalService.presentToast(result.message);
        this.location.back();
      }
    });
  }

  async deletePost(item: any): Promise<void> {
    const alert = await this.alertController.create({
      cssClass: 'remove-action-point-alert',
      header: this.translate.instant('hdl_delete_post'),
      message: this.translate.instant('txt_delete_post'),
      buttons: [
        {
          text: this.translate.instant('lbl_no'),
          role: 'cancel',
          cssClass: 'cancel-button',
          id: 'cancel-button',
          handler: () => {}
        },
        {
          text: this.translate.instant('lbl_yes'),
          id: 'confirm-button',
          cssClass: 'confirm-button',
          handler: () => {
            this.popoverCtrl.dismiss();
            this.postService.apiDeletePost(item.id).subscribe((result: ApiResponse) => {
              if (result.status) {
                this.navController.back();
                this.globalService.presentToast(this.translate.instant('txt_post_delete_success'));
              } else {
                this.globalService.presentToast(this.translate.instant('txt_post_delete_failure'));
              }
            });
          }
        }
      ]
    });

    await alert.present();
  }

  translatePost(item: any): Observable<any> {
    if (item.postTranslations?.title) {
      return of(item);
    }

    return this.postService.apiTranslatePost(item.id).pipe(
      map((result: ApiResponse) => {
        if (result.status) {
          return result.data;
        } else {
          throw new Error('Translation failed');
        }
      })
    );
  }
}
